import Image from 'next/image';
import Link from 'next/link';

export default function Footer() {
    const socials = [
        '/assets/svgs/fb.svg',
        '/assets/svgs/linkedin.svg',
        '/assets/svgs/x.svg',
        '/assets/svgs/insta.svg',
    ];
    return (
        // px-8
        // Hidden on mobile (PWA/WebView), shown on desktop
        <section className="hidden md:block bg-motitoBlack text-white">
            <div className="container mt-20 rounded-t-3xl   pt-16  sm:pt-16">
                <div className="flex flex-col items-center gap-5 sm:items-start">
                    <h1 className=" font-garnettSemiBold text-2xl sm:text-left sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
                        Get started today.
                    </h1>
                    <p className="text-center text-base sm:text-left">
                        Download motito app to start enjoying a good live with different
                        payment options
                    </p>
                </div>
                <div className="mt-5 flex w-full flex-col items-center justify-center gap-10 sm:grid sm:grid-cols-6">
                    <div className="col-span-2 flex flex-col gap-3 ">
                        {/*<span className="flex flex-wrap gap-2">*/}
                        {/*  <Image*/}
                        {/*      src="/assets/svgs/apple.svg"*/}
                        {/*      width={160}*/}
                        {/*      height={94}*/}
                        {/*      alt="icon"*/}
                        {/*      className="max-w-[100px]"*/}
                        {/*  />*/}
                        {/*  <Image*/}
                        {/*      src="/assets/svgs/play.svg"*/}
                        {/*      width={160}*/}
                        {/*      height={94}*/}
                        {/*      alt="icon"*/}
                        {/*      className="max-w-[100px]"*/}
                        {/*  />*/}
                        {/*</span>*/}
                        <div className="flex items-center justify-center gap-3 sm:justify-start">
                            {socials.map((social, index) => (
                                <Image
                                    key={index}
                                    src={social}
                                    width={87}
                                    height={46}
                                    alt="icon"
                                    className="size-10"
                                />
                            ))}
                        </div>
                    </div>
                    <div className="flex h-full flex-col  items-center  gap-2 px-2 text-sm sm:items-start ">
                        <h2 className="font-bold">Ways to Pay</h2>
                        <Link
                            href="https://motito.co/buy-now-pay-later.html"
                            target="_blank"
                        >
                            Credit- Buy now Paylater
                        </Link>
                        <Link href="https://motito.co/pay4me.html" target="_blank">
                            Pay4Me
                        </Link>
                        <Link href="https://motito.co/keep-my-price.html" target="_blank">
                            KeepMyPrice
                        </Link>
                    </div>
                    <div className="flex h-full flex-col  items-center  gap-2 px-2 text-sm sm:items-start ">
                        <h2 className="font-bold">Company</h2>
                        <Link href="https://motito.co/about-us.html" target="_blank">
                            About
                        </Link>
                        <Link href="">Careers </Link>
                        <Link href="https://blog.motito.co/" target="_blank">
                            Blog
                        </Link>
                    </div>
                    <div className="flex h-full flex-col  items-center  gap-2 px-2 text-sm sm:items-start ">
                        <h2 className="font-bold">Customer Service</h2>
                        <Link href="/dashboard">My Orders </Link>
                        <Link href="/dashboard/user-profile">My Account</Link>
                        <Link href="/policies">Return Police </Link>
                        <Link href="/faqs">FAQ</Link>
                    </div>
                    <div className="flex h-full flex-col  items-center  gap-2 px-2 text-sm sm:items-start ">
                        <h2 className="font-bold">Contact Us</h2>
                        <p>+233 59 601 1668 </p>
                        <Link href="">hello@motito.co</Link>
                    </div>
                </div>
                <footer
                    className="mt-12 flex w-full flex-col items-center justify-between gap-3 border-t border-t-muted px-8 py-6 text-xs sm:flex-row sm:px-16">
          <span className="flex gap-4">
            <p className="https://motito.co/terms-and-conditions.html">
              Terms & Conditions
            </p>
            <p className="https://motito.co/privacy-policy.html">
              Privacy Policy
            </p>
          </span>
                    <p>© 2024 motito Ltd, All rights reserved</p>
                </footer>
            </div>
        </section>
    );
}
